import { useMemo } from 'react'
import { useMealPlan } from '@/features/meal-plan/useMealPlan'
import { useGroceryList } from '@/features/grocery-list/useGroceryList'
import { getMondayOfWeek } from '@/features/meal-plan/utils'
import type { PlanStatus } from './types'

export function usePlanStatus(): { status: PlanStatus; isLoading: boolean } {
  const weekStartDate = useMemo(() => getMondayOfWeek(), [])
  const { data: plan, isLoading: planLoading } = useMealPlan(weekStartDate)
  const { data: groceryList, isLoading: listLoading } = useGroceryList()

  const status = useMemo<PlanStatus>(() => {
    const filledSlots = plan?.slots.filter(s => s.recipeId !== null).length ?? 0
    const hasItems = (groceryList?.items?.length ?? 0) > 0
    const tickedCount = groceryList?.items?.filter(i => i.ticked).length ?? 0

    if (hasItems && tickedCount > 0) return 'in-progress'
    if (hasItems) return 'generated'
    if (filledSlots > 0) return 'partial'
    return 'empty'
  }, [plan, groceryList])

  return { status, isLoading: planLoading || listLoading }
}
